import * as React from "react";
import { IBaseFieldProperty, IBaseProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { Button, Input, Label, Select } from "uxp/components";
import ActionButton from "../../components/ActionButton";
import ActionEditorLink, { IAction } from "../../action-editor/ActionEditor";
import { hasValue, parseValue } from "../../../../util";
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyTitle } from "../../ui-props/common";
import IconEditor, { generateIconPropAsSting } from "../../icon-selector/IconEditor";
import './Button.scss';
interface IButtonFieldProperty extends IBaseFieldProperty {
    title: string,
    fontSize?: string,
    color?: string,
    backgroundColor?: string,
    icon?: string,
    iconPosition?: 'left' | 'right'
    iconColor?: string,
    iconSize?: string
    onClick?: IAction,
    align?: string
}

export const Field: React.FunctionComponent<IUIFieldProps<IButtonFieldProperty>> = (props) => {
    let { mode, fieldProps, uiProps } = props
    let { title, fontSize, color, backgroundColor, icon, iconPosition, iconColor, iconSize, onClick, align } = fieldProps

    let styles: any = {};
    styles.textAlign = align || 'center'

    let buttonStyles: React.CSSProperties = {}
    if (hasValue(color)) buttonStyles.color = parseValue(color, props.contextData)
    if (hasValue(backgroundColor)) buttonStyles.backgroundColor = parseValue(backgroundColor, props.contextData)
    if (hasValue(fontSize)) buttonStyles.fontSize = fontSize

    let iconStyles: React.CSSProperties = {}
    if (hasValue(iconColor)) iconStyles.color = parseValue(iconColor, props.contextData)
    if (hasValue(iconSize)) iconStyles.fontSize = iconSize

   

    return (
        <div className={`ui-field uxp-button-wd ${props.mode} ${title ? '':'icon-only'}`} style={styles} >
            
            <ActionButton
                title={title}
                icon={generateIconPropAsSting(icon)}
                iconPosition={iconPosition}
                uxpContext={props?.fieldProps?.uxpContext}
                action={onClick}
                contextData={props?.fieldProps?.contextData || {}}
                styles={buttonStyles}
                iconStyles={iconStyles}
                onReloadWidget={() => {
                    if (uiProps.onReloadWidget) uiProps.onReloadWidget()
                }}
            />
        </div>
    )
}


export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IButtonFieldProperty>> = (props) => {

    let { uiProps, onChange, uxpContext, contextData } = props

    return <PropertyContainer>
        <PropertyContainerTitle> Action Button</PropertyContainerTitle>
        <PropertyGroup>
            {/* <PropertyGroupTitle>  </PropertyGroupTitle> */}
            <Property>
                <PropertyTitle>Title</PropertyTitle>
                <Input
                    value={uiProps.title}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { title: s }))}
                    className="widget-designer-input"
                />
            </Property>

            <Property>
                <PropertyTitle>On Click</PropertyTitle>
                <ActionEditorLink
                    uiProps={props.parentUIProps}
                    designer={props.designer}
                    uxpContext={uxpContext}
                    action={uiProps.onClick}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { onClick: s }))}
                    contextData={contextData}
                />
            </Property>

            <Property>
                <PropertyTitle>Align Button </PropertyTitle>
                <Select
                    selected={uiProps.iconPosition || 'center'}
                    options={[
                        { label: 'Left', value: 'left' },
                        { label: 'Right', value: 'right' },
                        { label: 'Center', value: 'center' },
                    ]}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { iconPosition: s }))}
                    className="widget-designer-input"
                />
            </Property>

            <Property>
                <PropertyTitle>Font Size (px) </PropertyTitle>
                <Input
                    type='number'
                    value={escapeUnit(uiProps.fontSize || '12', 'px')}
                    onChange={s => {
                        let num = Number(s) || 0
                        if (num < 8) s = '8'
                        else if (num > 200) s = '200'

                        props.onChange(Object.assign({}, uiProps, { fontSize: s + 'px' }))
                    }}
                    inputAttr={{
                        max: '200',
                        min: '8'
                    }}
                    className="widget-designer-input"
                />
            </Property>

            <Property>
                <PropertyTitle>Color</PropertyTitle>
                <CustomColorPicker contextData={props.contextData}
                    color={uiProps.color}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { color: s }))}
                />
            </Property>

            <Property>
                <PropertyTitle>Background Color</PropertyTitle>
                <CustomColorPicker contextData={props.contextData}
                    color={uiProps.backgroundColor}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { backgroundColor: s }))}
                />
            </Property>



            <Property>
                <PropertyTitle>Icon </PropertyTitle>
                <IconEditor
                    value={uiProps.icon}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { icon: s }))}
                />
            </Property>

            <Property>
                <PropertyTitle>Icon Color</PropertyTitle>
                <CustomColorPicker contextData={props.contextData}
                    color={uiProps.iconColor}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { iconColor: s }))}
                />
            </Property>

            <Property>
                <PropertyTitle>Icon Position </PropertyTitle>
                <Select
                    selected={uiProps.iconPosition || 'left'}
                    options={[
                        { label: 'Left', value: 'left' },
                        { label: 'Right', value: 'right' },
                    ]}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { iconPosition: s }))}
                    className="widget-designer-input"
                />
            </Property>

            <Property>
                <PropertyTitle>Icon Size (px) </PropertyTitle>
                <Input
                    type='number'
                    value={escapeUnit(uiProps.iconSize || '12', 'px')}
                    onChange={s => {
                        let num = Number(s) || 0
                        if (num < 8) s = '8'
                        else if (num > 200) s = '200'

                        props.onChange(Object.assign({}, uiProps, { iconSize: s + 'px' }))
                    }}
                    inputAttr={{
                        max: '200',
                        min: '8'
                    }}
                    className="widget-designer-input"
                />
            </Property>

        </PropertyGroup>;
    </PropertyContainer>

}

registerUIField({
    id: 'button',
    description: 'Button',
    field: Field,
    propertyEditor: PropertyEditor,
    defaultProps: {
        title: 'Submit',
        align: 'center',
    }
});


